(function () {

  'use strict';

  angular.module('AddUser')
    .controller('AddUserController', function (
      $scope, $location, $filter, URLS, $translate, focus,
      UserListService, toastr, EventHandlerService, currentTenant, CopilotService) {

      $scope.newUserDetails = {
        email: '',
        role: 'USER'
      };
      $scope.userEmailAddressFocusKey = 'userEmailAddressFocusKey';
      $scope.error = null;
      $scope.tenant = currentTenant;

      (function () {
        EventHandlerService.deRegisterListeners();
        fulfillCopilotRequest();
      })();

      function fulfillCopilotRequest() {
        const copilotParameters = CopilotService.useUserParameters();
        if (copilotParameters.email) {
          $scope.newUserDetails.email = copilotParameters.email;
        }
        if (copilotParameters.role) {
          if (copilotParameters.role === 'GUEST') {
            $scope.newUserDetails.role = 'GUEST_USER';
          } else if (copilotParameters.role === 'SYSTEM_OBSERVER') {
            $scope.newUserDetails.role = 'SYSTEM_OBSERVER';
          } else if (copilotParameters.role === 'SYSTEM_MANAGER') {
            $scope.newUserDetails.role = 'SYSTEM_MANAGER';
          }
        }
      }

      $scope.addUser = function (form, event) {
        if (form && event) {
          if (form.$invalid) {
            event.preventDefault();
          } else {
            const dataToSend = {
              email: $scope.newUserDetails.email,
              lang: $translate.use(),
              grantAdminAccess: $scope.newUserDetails.role === 'SYSTEM_MANAGER',
              role: $scope.newUserDetails.role
            };
            form.__customProperties.waitingForAnswer = true;
            UserListService.createUser(dataToSend)
              .then(function () {
                toastr.success($filter('translate')('EmailSent'));
                $location.path(URLS.USER_LIST);
              })
              .catch(function (error) {
                $scope.error = error;
              })
              .finally(function () {
                form.__customProperties.waitingForAnswer = false;
              });
          }
        }
      };

      $scope.clearError = function () {
        $scope.error = null;
      };

      focus($scope.userEmailAddressFocusKey);

    });

})();
